import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { Grid, GridColumn } from '@atlaskit/page';
import { SpotlightManager } from '@atlaskit/onboarding';

// @source
import {
  CreateUser, DeleteUser, EditUser, Header, Spotlight, TableView,
} from './components';
import { path } from '../../../utils';
import Layout from '../../templates/Layout';

const initialState = {
  spotlight: false,
};

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onClose = this.onClose.bind(this);
    this.onSpotlightToggle = this.onSpotlightToggle.bind(this);
  }

  onClose() {
    this.props.history.push('/users');
  }

  onSpotlightToggle() {
    this.setState({ spotlight: !this.state.spotlight });
  }

  render() {
    const type = this.props.match.params['0'];
    const uuid = path.parse('uuid');
    const props = {
      onClose: this.onClose,
      uuid,
    };

    return (
      <Layout>
        <Grid>
          <GridColumn>
            <SpotlightManager>
              <Header onSpotlightOpen={this.onSpotlightToggle} />
              <TableView />
              {type === 'create' ? <CreateUser onClose={this.onClose} /> : null}
              {type === 'edit' && uuid ? <EditUser {...props} /> : null}
              {type === 'delete' && uuid ? <DeleteUser {...props} /> : null}
              {this.state.spotlight ? (
                <Spotlight onSpotlightClose={this.onSpotlightToggle} />
              ) : null}
            </SpotlightManager>
          </GridColumn>
        </Grid>
      </Layout>
    );
  }
}

Users.propTypes = {
  history: PropTypes.shape().isRequired,
  match: PropTypes.shape().isRequired,
};

export default Users;
